// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AutomationEngineSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="AutomationEngineSignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M9.803 3.592C9.002 2.636 7.433 2.879 6.98 4.028L6.204 5.995l8.597 3.56z" />
      <path d="M3.111 13.83c-.453 1.15.547 2.343 1.802 2.15l1.697-.263-1.015-8.18z" />
      <path d="m15.171 9.998 1.458 1.74c.801.955.234 2.392-1.02 2.586L7.48 15.582z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AutomationEngineSignetIcon = /* @__PURE__ */ Object.assign(
  AutomationEngineSignetIconComponent,
  { displayName: 'AutomationEngineSignetIcon' },
);
